import { createSlice } from "@reduxjs/toolkit";

import { getOrderDetail } from "./thunk";
import { markOrderAsUnclaimed } from "../unclaimed/thunk";

export interface OrderDetailState {
    order: any;
    loading: {
        getOrder: boolean;
        markUnclaimed: boolean;
    };
    success: {
        getOrder: boolean;
        markUnclaimed: boolean;
    };
    error: string | null;
}

export const initialState: OrderDetailState = {
    order: null,
    loading: {
        getOrder: false,
        markUnclaimed: false,
    },
    success: {
        getOrder: false,
        markUnclaimed: false,
    },
    error: null,
};

const OrderDetailSlice = createSlice({
    name: "OrderDetail",
    initialState,
    reducers: {
        clearOrderDetail: (state) => {
            state.order = null;
            state.loading.getOrder = false;
            state.loading.markUnclaimed = false;
            state.success.getOrder = false;
            state.success.markUnclaimed = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getOrderDetail.pending, (state) => {
            state.loading.getOrder = true;
            state.success.getOrder = false;
            state.error = null;
        });
        builder.addCase(getOrderDetail.fulfilled, (state, action) => {
            state.order = action.payload.data;
            state.loading.getOrder = false;
            state.success.getOrder = true;
            state.error = null;
        });
        builder.addCase(getOrderDetail.rejected, (state) => {
            state.order = null;
            state.loading.getOrder = false;
            state.success.getOrder = false;
            state.error = "Không thể tải thông tin đơn hàng";
        });
        builder.addCase(markOrderAsUnclaimed.pending, (state) => {
            state.loading.markUnclaimed = true;
            state.success.markUnclaimed = false;
        });
        builder.addCase(markOrderAsUnclaimed.fulfilled, (state, action) => {
            state.loading.markUnclaimed = false;
            state.success.markUnclaimed = true;

            const payload = action.payload;
            let updatedOrder: any = undefined;

            if (payload) {
                const responseData: any = (payload as any).data;
                if (responseData && typeof responseData === "object") {
                    updatedOrder = responseData.order ?? responseData;
                } else if (typeof payload === "object") {
                    const payloadObject = payload as Record<string, any>;
                    updatedOrder = payloadObject.order ?? payloadObject;
                }
            }

            if (updatedOrder && typeof updatedOrder === "object") {
                const normalizedStatus = updatedOrder.status ?? updatedOrder.order_status ?? updatedOrder.state;
                state.order = {
                    ...(state.order ?? {}),
                    ...updatedOrder,
                    status: normalizedStatus ?? "unclaimed",
                };
            } else if (state.order) {
                state.order = {
                    ...state.order,
                    status: "unclaimed",
                };
            }
        });
        builder.addCase(markOrderAsUnclaimed.rejected, (state, action) => {
            state.loading.markUnclaimed = false;
            state.success.markUnclaimed = false;
            state.error = typeof action.error?.message === "string" ? action.error.message : state.error;
        });
    },
});

export const { clearOrderDetail } = OrderDetailSlice.actions;
export default OrderDetailSlice.reducer;
